import React, { Component } from 'react';

import { MfaEnableApp } from "./app/mfa-app";
import { MfaEnableEmail } from "./email/mfa-email";
import { MfaEnableTextMessage } from "./mfa-text-message";

import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";

class MfaCurrentProvider extends Component {
    state = {  } 
    render() { 
        const { provider, userId, orgId, onVerify, enabled, messages} = this.props;
        const props = { userId, orgId, onVerify, enabled, messages};

        if (provider === MFA_AUTHENTICATION_TYPES.APP) {
            return <MfaEnableApp {...props} />;
        } else if (provider === MFA_AUTHENTICATION_TYPES.EMAIL) {
            return <MfaEnableEmail {...props} />;
        } else if (provider === MFA_AUTHENTICATION_TYPES.TEXTMESSAGE) {
            return <MfaEnableTextMessage {...props} />;
        }

        return null;
    }
}
 
export {MfaCurrentProvider};